import React from "react";
import { Document } from "@customTypes/responses/document";
import {
  AttachmentContainer,
  DocumentItemContainer,
  DownloadAllButton,
  TitleContainer,
} from "./style";
import { formatISODate } from "@helpers/dateHelpers";
import { NormalText } from "@components/styles/dataDisplay";
import { FiPaperclip } from "@react-icons/all-files/fi/FiPaperclip";
import { useTheme } from "emotion-theming";
import { StandardTheme } from "@nectarTypes";
import { backendBlobRequest } from "@services/requestService";
import AttachmentList from "./AttachmentList";
import DocumentItemDownloader from "./DocumentItemDownload";
import AttachedLawsuit from "./AttachedLawsuit";

type DocumentItemProps = {
  document: Document;
  showRootLawsuit?: boolean;
};

const DocumentItem: React.FC<DocumentItemProps> = ({ document, showRootLawsuit }) => {
  const { documentName, updateDate, attachments, downloadUrls } = document;

  const handleDownloadAll = async () => {
    if (!downloadUrls[0]) return;
    const response = await backendBlobRequest(downloadUrls[0], "GET");
    const invisibleLink = window.document.createElement("a");
    invisibleLink.href = window.URL.createObjectURL(response);
    invisibleLink.setAttribute("download", documentName);
    invisibleLink.click();
    invisibleLink.remove();
  };

  const theme = useTheme<StandardTheme>();

  const shouldShowDownloadAllButton = attachments?.length > 1;

  return (
    <DocumentItemContainer>
      <NormalText>{formatISODate(updateDate)}</NormalText>
      <div>
        <TitleContainer>
          <FiPaperclip size={16} color={theme.colors.gray500} rotate={90} />
          <NormalText>{documentName}</NormalText>
        </TitleContainer>
        <AttachmentContainer>
          {attachments ? (
            <AttachmentList attachments={attachments} />
          ) : (
            <DocumentItemDownloader document={document} />
          )}
        </AttachmentContainer>
        {showRootLawsuit && document.case?.id && <AttachedLawsuit attachedCase={document.case} />}
      </div>
      {shouldShowDownloadAllButton && (
        <DownloadAllButton outline color="primary" block onClick={handleDownloadAll}>
          Baixar todos os arquivos
        </DownloadAllButton>
      )}
    </DocumentItemContainer>
  );
};

export default DocumentItem;
